var path = 'components/streams/tooltips/transcodingStatus.organizations.html';
var html = "<div> <div ng-repeat=\"org in row.organizations | orderBy:vm.organizationSortKey track by $index\"> <span ng-bind=vm.organizationDisplayName(org)></span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;